/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phasereview1Inputs */

const en_phasereview1 = /** @type {(inputs: Phasereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for review`)
};

const pt_phasereview1 = /** @type {(inputs: Phasereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto para revisão`)
};

/**
* | output |
* | --- |
* | "Ready for review" |
*
* @param {Phasereview1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const phasereview1 = /** @type {((inputs?: Phasereview1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phasereview1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phasereview1(inputs)
	return pt_phasereview1(inputs)
});
export { phasereview1 as "phaseReview" }